export const Menu = () => {
    return {
        selected: false,
        sticky: false,
        stickyType: 'show',
        previousPosition: 0,

        init () {
            this.previousPosition = window.scrollY;
            if(window.openForm) {
                this.open('form');
            }
        },

        open(index = true, toggle = true) {
            if(!toggle) {
                this.selected = index;
            } else {
                this.selected = this.isOpen( index ) ? false : index;
            }

            document.body.classList.remove('is-open-form');
            document.body.classList.remove('is-open-menu');

            if(this.isOpen('form')) {
                document.body.classList.add('is-open-form');
            } else if(this.isOpen('menu')) {
                document.body.classList.add('is-open-menu');
            }
        },

        isOpen(index = true) {
            if(index == true) {
                return this.selected != false;
            }
            return this.selected === index;
        },

        checkSticky() {
            const currentPosition = window.scrollY;
            if(currentPosition < 600) {
                this.sticky = false;
            } else {
                this.sticky = true;
            }

            this.stickyType =  (this.previousPosition > currentPosition) ? 'show' : 'hide';

            this.previousPosition = currentPosition;
        },

        isStuck() {
            return this.sticky;
        },

        stuckType(type) {
            return this.stickyType == type;
        },

        checkClose(event) {
            if( event.srcElement.classList.contains('c-button') ||
                event.srcElement.classList.contains('c-arrow-button')) {
                return;
            }

            this.open(false, false);
        }
    }
}
